import { render } from "./client-groups.vue?vue&type=template&id=1c1f2e37"
import script from "./client-groups.vue?vue&type=script&lang=js"
export * from "./client-groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__